import React, { useMemo } from 'react';
import { useTheme } from '../context/ThemeContext';

interface StainConfig {
  color: string;
  opacity: string;
  sizeRange: [number, number];
}

export const BackgroundStains: React.FC = () => {
  const { theme } = useTheme();

  const generateRandomStain = (color: string, opacity: string, sizeRange: [number, number]) => {
    const [min, max] = sizeRange;
    const size = Math.floor(Math.random() * (max - min) + min);
    const top = Math.random() * 100;
    const left = Math.random() * 100;

    return (
      <div
        key={`${color}-${top}-${left}`}
        className="absolute rounded-full blur-3xl transition-colors duration-500"
        style={{
          backgroundColor: color,
          opacity: parseFloat(opacity),
          width: `${size}px`,
          height: `${size}px`,
          top: `${top}%`,
          left: `${left}%`,
        }}
      />
    );
  };

  const stains = useMemo(() => 
    theme === "dark"
      ? [
          { color: "rgb(34, 197, 94)", opacity: "0.5", sizeRange: [200, 400] as [number, number] },
          { color: "rgb(255, 255, 255)", opacity: "0.3", sizeRange: [150, 300] as [number, number] },
        ]
      : [
          { color: "rgb(34, 197, 94)", opacity: "0.5", sizeRange: [200, 400] as [number, number] },
          { color: "rgb(0, 0, 0)", opacity: "0.3", sizeRange: [150, 300] as [number, number] },
        ],
    [theme]
  );

  return (
    <div className={`fixed inset-0 -z-10 transition-colors duration-500 ${theme === "dark" ? "bg-black" : "bg-white"}`}>
      {stains.map((stain, index) =>
        Array.from({ length: 3 }).map((_, i) =>
          generateRandomStain(stain.color, stain.opacity, stain.sizeRange)
        )
      )}
    </div>
  );
};
